<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">View Shift</h4>
                </md-card-header>
                <md-card-content>
                    <div class="text-right">
                        <md-button @click="goBack" class="md-primary md-dense">
                            Back to List
                        </md-button>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <md-card>
                                        <md-card-content>
                                            <md-table >
                                                <md-table-row>
                                                    <md-table-cell>Name</md-table-cell> <md-table-cell>{{shift.name}}</md-table-cell>
                                                </md-table-row>
                                                <md-table-row>
                                                    <md-table-cell>Code</md-table-cell> <md-table-cell>{{shift.code}}</md-table-cell>
                                                </md-table-row>
                                                <md-table-row>
                                                    <md-table-cell>Short  Name</md-table-cell> <md-table-cell>{{shift.short_name}}</md-table-cell>
                                                </md-table-row>
                                            </md-table>
                                            <md-button  class="md-white md-primary"
                                                        @click="goToEdit(shift.id)"
                                                        style="margin: 0.2rem"
                                            >Edit shift </md-button>
                                        </md-card-content>
                                    </md-card>
                                </div>
                            </div>
                        </div>
                        <div></div>
                        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50">
                            <nav-tabs-card>
                                <template slot="content">
                                    <span class="md-nav-tabs-title">Ports:</span>
                                    <md-tabs class="md-primary md-white" md-alignment="left">
                                        <md-tab id="tab-home" md-label="Port List" md-icon="bug_report">
                                            <md-table v-model="port" @md-selected="onSelect">
                                                <md-table-row v-for="portData in port " :key='portData.id'>
                                                    <md-table-cell>{{ portData.name }}  </md-table-cell>
                                                    <md-table-cell>{{ portData.code }} </md-table-cell>
                                                    <md-table-cell>{{ portData.short_name }}</md-table-cell>
                                                    <md-table-cell>
                                                        <md-button class="md-just-icon md-simple md-primary">
                                                            <md-icon>edit</md-icon>
                                                            <md-tooltip md-direction="top">Edit</md-tooltip>
                                                        </md-button>
                                                        <md-button class="md-just-icon md-simple md-danger">
                                                            <md-icon>close</md-icon>
                                                            <md-tooltip md-direction="top">Close</md-tooltip>
                                                        </md-button>
                                                    </md-table-cell>
                                                </md-table-row
                                                >
                                            </md-table>
                                        </md-tab>
                                    </md-tabs>
                                </template>
                            </nav-tabs-card>
                        </div>

                    </div>


                </md-card-content>
            </md-card>
        </div>
    </div>
</template>

<script>
import {
    NavTabsCard
} from '@/components';

export default {
    components: {
        NavTabsCard,

    },
    props: {
        profileCard: {
            type: String,
            default: process.env.VUE_APP_BASE_URL + '/img/faces/card-profile1-square.jpg'
        }
    },
    data () {
        return {
            selected: [],
            responsive: false,
            shift: {
                type: 'shifts',
                name: null,
                id:null,
                short_name: null,
                code: null,
            },
            port: {
                type: 'ports',
                name: null,
                id:null,
                short_name: null,
                code: null,
                shift_id: null
            },

        };
    },

    created () {
        this.get();
        this.getPorts();
    },

    methods: {
        goToEdit (id) {
            this.$router.push({ name: 'Edit Station', params: { id } });
        },
        onSelect: function (items) {
            this.selected = items;
        },
        onResponsiveInverted () {
            if (window.innerWidth < 768) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        },
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('shifts/get', id);
                this.shift = this.$store.getters['shifts/shift'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async getPorts () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('stations/ports', id);
                this.port = this.$store.getters['stations/list'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        goBack () {
            this.$router.push({ name: 'Shifts List' });
        },
    },
    mounted () {
        this.onResponsiveInverted();
        window.addEventListener('resize', this.onResponsiveInverted);
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.onResponsiveInverted);
    },

};
</script>

<style lang="css"></style>
